<!-- cl-spacing-none: the first thing in the item card body; a top margin here collapsed out of
     .card-body and showed the section background as a grey band under the card header. -->
<div class="row cl-spacing-none" [formGroup]="form">
  <div class="col-12 col-md-4">
    <label for="input_brefix" class="form-label">Source Folder </label>
    <input id="input_brefix" type="text" formControlName="input_brefix" readonly [class.invalid]="showInvalid('input_brefix')">
    @if (form.controls.input_brefix.errors?.required) {
      <p class="invalid-feedback">This field is
      required.</p>
    }
    @if (!form.controls.input_brefix.errors) {
      <p class="valid-feedback">You can
        <a [routerLink]="'o/' + organization.id +  '/files/browse/' + form.controls.input_brefix.value  ">navigate to the source folder</a>
      </p>
    }
  </div>
  <div class="col-12 col-md-4">
    <label for="po_item_id" class="form-label">Encode ID<span class="required">*</span></label>
    <input id="po_item_id" type="text" formControlName="po_item_id" [pattern]="poItemIdPattern"
           [class.invalid]="showInvalid('po_item_id')">
    @if (form.controls.po_item_id.errors?.required) {
      <p class="invalid-feedback">This field is required.</p>
    } @else if (form.controls.po_item_id.errors?.pattern) {
      <p class="invalid-feedback">{{ poItemIdPatternDescription }}</p>
    } @else if (form.controls.po_item_id.errors?.s3TagValueTooLong; as tooLong) {
      <p class="invalid-feedback">The title is too long: it encodes to {{ tooLong.encoded }} of at most {{ tooLong.max }}
      characters. Characters outside <code>A-Z a-z 0-9 + - = . _ :</code> need three characters
      each when encoded.</p>
    }
    <p class="valid-feedback">Name to identify the encoding job.</p>
  </div>
  <div class="col-12 col-md-4"  (paste)="onPaste($event)">
    <label for="filename" class="form-label">Output Name @if(this.ife_format && this.ife_format.filename !== '') {<span class="required">*</span>}</label>
    <input id="filename" type="text" formControlName="filename" [class.invalid]="showInvalid('filename')">
    @if (form.controls.filename.errors?.required) {
      <p class="invalid-feedback">This field is required.</p>
    }
    <p class="valid-feedback valid-feedback-none"></p>
  </div>

</div>
